export class DroppZipResponse {

  status: number;
  message: string;

  /**
   * The zip codes which support articles being delivered home directly
   */
  codes: DroppZipModel[] = [];

  /**
   * The zip codes which support articles being delivered to samskip
   * location where the package can be picked up
   */
  flytjandicodes: DroppZipModel[] = [];

  static generate(json: any): DroppZipResponse {

    const res = new DroppZipResponse();
    res.status = json.status;
    res.message = json.message;
    res.codes = DroppZipModel.generateList(json['codes']);
    res.flytjandicodes = DroppZipModel.generateList(json['flytjandicodes']);

    return res;

  }

  findZip(zip: number): DroppZipModel {

    for (const areaCode of this.codes) {

      if (areaCode.code === zip) {
        return areaCode;
      }

    }

    return null;
  }

  supportsHomeDelivery(zip: number): boolean {

    for (const areaCode of this.codes) {
      if (areaCode.code === zip) {
        return true;
      }
    }

    return false;
  }

  supportsFlytjandiDelivery(zip: number): boolean {

    for (const areaCode of this.flytjandicodes) {
      if (areaCode.code === zip) {
        return true;
      }
    }

    return false;
  }

}

export class DroppZipModel {

  code: number;
  town: string;
  capital = false;

  static generate(json: any): DroppZipModel {

    const delivery = new DroppZipModel();
    delivery.code = json['code'];
    delivery.town = json['town'];
    delivery.capital = json['capital'];

    return delivery;

  }

  static generateList(jsonList: any[]): DroppZipModel[] {

    const list = [];
    for (const json of jsonList) {
      list.push(this.generate(json));
    }

    return list;

  }

}
